<template>
	<div v-if="title != ''" class="title">
		{{title}}
	</div>
	<div v-else class="tip_view">
		Tip：{{tip}}
	</div>
</template>

<script>
	export default {
		props:{
			tip:{
				type:String,
				default:''
			},
			title:{
				type:String,
				default:''
			}
		}
	}
</script>

<style scoped>
	.title{
		font-size: 24px;
		color: #000;
	}
	.tip_view{
		width: calc(100% - 40px);
		padding: 0 20px;
		height: 35px;
		display: flex;
		align-items: center;
		color: var(--theme-color);
		font-size: 14px;
		background: var(--theme-color2);
		border-radius: 35px;
	}
</style>